export default "__VITE_ASSET__46yuC5MK__"